import SuccessNotification from './SuccessNotification';

export default SuccessNotification;
